import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoriesSection() {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按分类发现你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className={`${cat.icon} text-lg md:text-xl text-accent-600`}></i>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}